'use strict';

var _regeneratorRuntime = require("/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");
var _asyncToGenerator = require("/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _defineProperty = require("/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _possibleConstructorReturn = require("/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _wrapNativeSuper = require("/app/Marketplace/ClientApp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var retry = require('retry');
var AbortError = /*#__PURE__*/function (_Error) {
  _inherits(AbortError, _Error);
  function AbortError(message) {
    var _this;
    _classCallCheck(this, AbortError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbortError).call(this));
    if (message instanceof Error) {
      _this.originalError = message;
      var _message = message;
      message = _message.message;
    } else {
      _this.originalError = new Error(message);
      _this.originalError.stack = _this.stack;
    }
    _this.name = 'AbortError';
    _this.message = message;
    return _this;
  }
  return AbortError;
}(_wrapNativeSuper(Error));
var decorateErrorWithCounts = function decorateErrorWithCounts(error, attemptNumber, options) {
  // Minus 1 from attemptNumber because the first attempt does not count as a retry
  var retriesLeft = options.retries - (attemptNumber - 1);
  error.attemptNumber = attemptNumber;
  error.retriesLeft = retriesLeft;
  return error;
};
var pRetry = function pRetry(input, options) {
  return new Promise(function (resolve, reject) {
    options = _objectSpread({
      onFailedAttempt: function onFailedAttempt() {},
      retries: 10
    }, options);
    var operation = retry.operation(options);
    operation.attempt( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(attemptNumber) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.t0 = resolve;
                _context.next = 4;
                return input(attemptNumber);
              case 4:
                _context.t1 = _context.sent;
                (0, _context.t0)(_context.t1);
                _context.next = 14;
                break;
              case 8:
                _context.prev = 8;
                _context.t2 = _context["catch"](0);
                if (_context.t2 instanceof Error) {
                  _context.next = 13;
                  break;
                }
                reject(new TypeError("Non-error was thrown: \"".concat(_context.t2, "\". You should only throw errors.")));
                return _context.abrupt("return");
              case 13:
                if (_context.t2 instanceof AbortError) {
                  operation.stop();
                  reject(_context.t2.originalError);
                } else if (_context.t2 instanceof TypeError) {
                  operation.stop();
                  reject(_context.t2);
                } else {
                  decorateErrorWithCounts(_context.t2, attemptNumber, options);
                  options.onFailedAttempt(_context.t2);
                  if (!operation.retry(_context.t2)) {
                    reject(operation.mainError());
                  }
                }
              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });
};
module.exports = pRetry;
// TODO: remove this in the next major version
module.exports.default = pRetry;
module.exports.AbortError = AbortError;